import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "fixed inset-0 z-40 overflow-hidden lg:hidden",
  "aria-modal": "true"
}
const _hoisted_2 = { class: "absolute inset-0 z-40 flex pointer-events-none" }
const _hoisted_3 = { class: "flex-1 max-w-sm min-w-0 bg-opacity-75 border-r border-white pointer-events-auto border-opacity-10 bg-gray-900 backdrop-filter backdrop-blur firefox:bg-opacity-90" }
const _hoisted_4 = { class: "py-6 space-y-4 text-gray-500 h-full w-full" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M6 18L18 6M6 6l12 12"
  })
], -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "w-24 pointer-events-none" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogOverlay = _resolveComponent("DialogOverlay")!
  const _component_TransitionChild = _resolveComponent("TransitionChild")!
  const _component_SidebarContent = _resolveComponent("SidebarContent")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_TransitionRoot = _resolveComponent("TransitionRoot")!

  return (_openBlock(), _createBlock(_component_TransitionRoot, {
    appear: "",
    show: _ctx.isOpen,
    as: "template"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Dialog, {
        as: "div",
        static: "",
        open: _ctx.isOpen
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_TransitionChild, {
              as: "template",
              enter: "duration-200 ease-out",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "duration-200 ease-in",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DialogOverlay, {
                  class: "bg-gray-900 absolute inset-0 backdrop-filter backdrop-blur bg-opacity-50",
                  "aria-hidden": "true",
                  onClick: _ctx.closeSidebar
                }, null, 8, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_TransitionChild, {
              as: "template",
              enter: "duration-500 ease-in-out",
              "enter-from": " transform -translate-x-full ",
              "enter-to": " transform translate-x-0 ",
              leave: "duration-500 ease-in-out",
              "leave-from": "transform translate-x-0 ",
              "leave-to": "transform -translate-x-full "
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("button", {
                        class: "text-white opacity-80 hover:opacity-100 absolute top-3 right-3 sm:top-4 sm:right-4 focus:outline-none cursor-pointer transform transition hover:scale-125",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeSidebar && _ctx.closeSidebar(...args)))
                      }, _hoisted_6),
                      _createVNode(_component_SidebarContent)
                    ])
                  ]),
                  _hoisted_7
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["open"])
    ]),
    _: 1
  }, 8, ["show"]))
}